import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import labService from './labService';
import authService from '../auth/authService';
import './css/CalculatingPrediction.css';

const CalculatingPrediction = ({ isCollapsed, toggleSidebar }) => {
  const navigate = useNavigate();
  const { pk } = useParams(); // Pobieramy ID analizy z URL

  const backToPredList = () => {
    navigate('/laboratory');
  };

  useEffect(() => {
    // Jeśli z jakiegoś powodu nie ma ID w linku, nie robimy nic
    if (!pk) return;

    const checkComputationStatus = async () => {
      try {
        const token = authService.getCurrentUser()?.access;
        if (!token) return;

        // Odpytanie backendu o status obliczeń
        const response = await labService.checkComputationStatus(pk, token);

        if (response.data.redirect_url) {
          // Jeśli celery skończyło pracę, backend wysyła link do strony wyników
          navigate(response.data.redirect_url);
        }
      } catch (error) {
        console.error("Error fetching computation status:", error);
      }
    };

    // Odpytywanie backendu co 10 sekund
    const intervalId = setInterval(checkComputationStatus, 10000);

    // Pierwsze odpytanie natychmiast po wejściu na stronę
    checkComputationStatus();

    // Sprzątanie po wyjściu z tego ekranu
    return () => clearInterval(intervalId);
  }, [pk, navigate]);

  return (
    <div className='lab-container'>
      <Navbar />
      <div className='calculating-prediction'>
        <div className="spinner-container">
          <div className="spinner-div">
            <span className="spinner">Waiting for prediction's results</span>
          </div>
          <p className="prediction-results-info">Your prediction results are almost ready!</p>
          <div className="back-to-laboratory-button" onClick={() => backToPredList()}>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1rem" width="1rem" xmlns="http://www.w3.org/2000/svg">
              <path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292"></path>
            </svg>
            <p className="back-to-lab-button-string">Back to predictions list</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CalculatingPrediction;
